/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Transfer_Customer_CodeInputs */

const en_reference_field_transfer_customer_code = /** @type {(inputs: Reference_Field_Transfer_Customer_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer customer code`)
};

/**
* | output |
* | --- |
* | "Transfer customer code" |
*
* @param {Reference_Field_Transfer_Customer_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_transfer_customer_code = /** @type {((inputs?: Reference_Field_Transfer_Customer_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Transfer_Customer_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_transfer_customer_code(inputs)
});